module.exports = __webpack_public_path__ + "static/media/wizualizacja-15.f71b4f40.png";